var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"dropdown-item",attrs:{"href":_vm.url,"data-testid":"dropdown-button"},on:{"click":() => _vm.trackMenuEvent(_vm.itemName)}},[_c('BaseText',{attrs:{"as":"span","size":"sm"}},[_vm._v(_vm._s(_vm.itemName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }